import React from 'react';
import { Icon } from './Icon.js';
export const IconStairsFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "M1.75 11.5C1.05964 11.5 0.5 10.9404 0.5 10.25V8.25C0.5 7.55964 1.05964 7 1.75 7H3.5V4.75C3.5 4.05964 4.05964 3.5 4.75 3.5H7V1.75C7 1.05964 7.55964 0.5 8.25 0.5L10.25 0.5C10.9404 0.5 11.5 1.05964 11.5 1.75V10.25C11.5 10.9404 10.9404 11.5 10.25 11.5H1.75Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconStairsFill12.js.map